import React from 'react'

import { TextClamp } from '../components/text/TextClamp'

/**
 * A data slide's footer (`footerText`): its base and its split's small-group note,
 * bottom right in the footer tone. One element for every layout that draws it, so a
 * footer the pipeline writes is never left undrawn on one slide type.
 */
export function SlideFootnote({ text }: { text?: string | null }) {
  const normalized = (text || '').replace(/\s+/g, ' ').trim()
  if (!normalized) return null
  return (
    <div
      data-testid="slide-footnote"
      style={{
        position: 'absolute',
        right: 40,
        bottom: 18,
        maxWidth: 'calc(100% - 80px)',
        fontSize: 'var(--ds-fs-footer)',
        color: 'var(--ds-text-faint)',
        textAlign: 'right',
      }}
    >
      <TextClamp minLines={1} maxLines={1} lineHeight="var(--ds-lh-snug)">
        {normalized}
      </TextClamp>
    </div>
  )
}
